export const SET_TRADE_INFO = "SET_TRADE_INFO";
export const SET_TRADE_FORM_DETAIL = "SET_TRADE_FORM_DETAIL";
export const SET_LANGUAGE = "SET_LANGUAGE";
export const SET_PRIVACY_POLICY = "SET_PRIVACY_POLICY";
